<script>
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'LineBreak',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle',
                    version: '1.1.0',
                    desc: 'Line Break Chart',
                    preset: {
                        name: 'LineBreak',
                        side: 'onchart',
                        settings: {
                            lines: 3,
                            colorCandleUp: '#23a776',
                            colorCandleDw: '#e54150',
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {},
            draw(ctx) {
                let layout = this.$props.layout

                if (this.$props.sub === this.$props.data) {
                    var candles = layout.candles
                } else {
                    candles = layout_cnv(this).candles
                }

                if (!candles || candles.length === 0) return

                let numLines = Math.max(parseInt(this.sett.lines, 10) || 3, 1)
                let bars = this.buildLineBreakBars(candles, numLines, layout)

                for (var i = 0, n = bars.length; i < n; i++) {
                    this.drawLineBreakBar(ctx, bars[i])
                }
            },
            buildLineBreakBars(candles, numLines, layout) {
                if (!candles.length) return []

                let lines = []
                let step = this.getBarStep(candles)
                let nextX = candles[0].x
                let first = candles[0].raw
                let firstOpen = first[1]
                let firstClose = first[4]
                let firstGreen = firstClose >= firstOpen

                lines.push({
                    open: firstOpen,
                    close: firstClose,
                    high: Math.max(firstOpen, firstClose),
                    low: Math.min(firstOpen, firstClose),
                    green: firstGreen
                })

                for (var i = 1, n = candles.length; i < n; i++) {
                    let close = candles[i].raw[4]
                    let last = lines[lines.length - 1]
                    let recent = lines.slice(-numLines)
                    let highest = Math.max(...recent.map(x => x.high))
                    let lowest = Math.min(...recent.map(x => x.low))

                    if (last.green && close > last.close) {
                        lines.push({
                            open: last.close,
                            close,
                            high: Math.max(last.close, close),
                            low: Math.min(last.close, close),
                            green: true
                        })
                    } else if (!last.green && close < last.close) {
                        lines.push({
                            open: last.close,
                            close,
                            high: Math.max(last.close, close),
                            low: Math.min(last.close, close),
                            green: false
                        })
                    } else if (close > highest) {
                        lines.push({
                            open: last.close,
                            close,
                            high: Math.max(last.close, close),
                            low: Math.min(last.close, close),
                            green: true
                        })
                    } else if (close < lowest) {
                        lines.push({
                            open: last.close,
                            close,
                            high: Math.max(last.close, close),
                            low: Math.min(last.close, close),
                            green: false
                        })
                    }
                }

                return lines.map(line => {
                    let o = Math.floor(line.open * layout.A + layout.B)
                    let c = Math.floor(line.close * layout.A + layout.B)
                    let h = Math.floor(line.high * layout.A + layout.B)
                    let l = Math.floor(line.low * layout.A + layout.B)
                    let bar = {
                        x: nextX,
                        w: step * 0.9,
                        o,
                        c,
                        h: Math.min(h, l),
                        l: Math.max(h, l),
                        green: line.green
                    }
                    nextX += step
                    return bar
                })
            },
            drawLineBreakBar(ctx, data) {
                let color = data.green ? this.upColor : this.downColor

                let w = Math.max(data.w, 1)
                let hw = Math.max(Math.floor(w * 0.5), 1)
                let h = Math.abs(data.o - data.c)
                let max_h = data.c === data.o ? 1 : 2
                let x05 = Math.floor(data.x) - 0.5

                if (data.w > 1.5) {
                    let s = data.green ? 1 : -1
                    let bodyX = Math.floor(data.x - hw - 1)
                    let bodyW = Math.floor(hw * 2 + 1)
                    let bodyH = s * Math.max(h, max_h)

                    if (data.green) {
                        // Hollow for up
                        ctx.strokeStyle = color
                        ctx.lineWidth = 1.5
                        ctx.strokeRect(bodyX, data.c, bodyW, bodyH)
                    } else {
                        // Filled for down
                        ctx.fillStyle = color
                        ctx.fillRect(bodyX, data.c, bodyW, bodyH)
                    }
                } else {
                    ctx.strokeStyle = color
                    ctx.beginPath()
                    ctx.moveTo(x05, Math.floor(Math.min(data.o, data.c)))
                    ctx.lineTo(x05, Math.floor(Math.max(data.o, data.c)) + (data.o === data.c ? 1 : 0))
                    ctx.stroke()
                }
            },
            getBarStep(candles) {
                if (candles.length < 2) return Math.max(candles[0].w || 5, 5)
                let first = candles[0].x
                let last = candles[candles.length - 1].x
                let step = Math.abs(last - first) / Math.max(candles.length - 1, 1)
                return Math.max(step || candles[0].w || 5, 3)
            },
            use_for() { return ['LineBreak'] },
            y_range() {
                var hi = -Infinity, lo = Infinity
                for (var i = 0, n = this.sub.length; i < n; i++) {
                    let x = this.sub[i]
                    if (x[2] > hi) hi = x[2]
                    if (x[3] < lo) lo = x[3]
                }
                return [hi, lo]
            }
        },
        computed: {
            sett() { return this.$props.settings },
            upColor() { return this.sett.colorCandleUp || this.$props.colors.candleUp || '#23a776' },
            downColor() { return this.sett.colorCandleDw || this.$props.colors.candleDw || '#e54150' },
            lineWidth() { return this.sett.lineWidth || 1 }
        }
    }
</script>
